import { RefSelectProps, Select, SelectProps } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { forwardRef, ForwardRefRenderFunction, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { filterValueByCriteria } from '../../../../shared/utils/filter-value-by-criteria/filter-value-by-criteria';
import { useGetClientUsersUnitsQuery } from '../../api/client-users-api';

type Props = Omit<SelectProps, 'filterOption' | 'showSearch' | 'onSearch' | 'onBlur'>;

const ClientUsersUnitSelect: ForwardRefRenderFunction<RefSelectProps, Props> = (props, ref) => {
  const { t } = useTranslation('common');
  const { data: userUnits } = useGetClientUsersUnitsQuery();

  const unitSelectOptions: DefaultOptionType[] = useMemo(() => {
    return (Array.isArray(userUnits) ? userUnits : []).map(userUnit => ({
      label: userUnit,
      value: userUnit,
    }));
  }, [userUnits]);

  return (
    <Select
      ref={ref}
      filterOption={(inputValue, option) => filterValueByCriteria((option?.label ?? '').toString(), inputValue)}
      showSearch
      allowClear={true}
      placeholder={t('label.unit')}
      options={unitSelectOptions}
      {...props}
    />
  );
};
export default forwardRef(ClientUsersUnitSelect);
